import React, { memo } from 'react';
import BlacklistPopup from './BlacklistPopup';
import { ExtraProps } from '../../popup/ButtonPopup/ButtonPopup';

const BlacklistPopupAdapter: React.FC<{
  open: boolean;
  onClose: () => void;
  extra?: ExtraProps;
}> = ({ open, onClose, extra }) => {
  return (
    <BlacklistPopup
      open={open}
      onCancel={onClose}
      onSuccess={extra?.onSuccess}
    />
  );
};

export default memo(BlacklistPopupAdapter);
